/*****************************************************************************************
 * 설명 : 통계관리 > 열람통계
 * URI : /statistic/access
 * 작성자 :
 * 작성일 :
*****************************************************************************************/
import AgGridReact from 'components/agGridReactEx';
import { useFormik } from 'formik';
import * as moment from 'moment';
import { useEffect, useState } from 'react';
import * as Yup from "yup";

import Restful from 'service/restful';
import { getStatisticAccessApi } from 'service/statistic';
import { formatBytes } from 'service/utils';

import { BtnRefresh, BtnSearch } from 'components/common';
import { InputEx } from 'components/inputEx';
import customTooltipAgGrid from 'components/tooltipAgGrid';

import Layout from 'pages/layout/layout';

import 'assets/css/pages/statistic.scss';

/*****************************************************************************************
 * 설명 : 함수 선언
*****************************************************************************************/
const StatisticAccess = (props) => {

  /***************************************************************************************
   * 설명 : 변수 선언부
  ***************************************************************************************/
  const [getApi] = Restful();

  const [list1, setList1] = useState([]);
  const [list2, setList2] = useState([]);
  const [list3, setList3] = useState([]);
  const [list4, setList4] = useState([]);

  const initialValues = {
    startDate: moment().format('YYYY-MM'),
  }

  const formik = useFormik({
    initialValues: initialValues,
    validationSchema: Yup.object().shape({
    }),
    onSubmit: (values) => {
      getList();
    }
  });

  // table column
  const [columnDefsProject] = useState([
    { headerName:'순위', field: 'rankNo', width: 45, cellClass: 'cp center' },
    { headerName:'프로젝트', field: 'projectNumber', width: 100, cellClass: 'cp center' },
    { headerName:'프로젝트명', field: 'word', flex: 1, width: 190, cellClass: 'cp' },
    { headerName:'이전순위', field: 'prevRankNo', width: 80, cellClass: 'cp center',
      cellRendererFramework: function(params) {
        if( parseInt(params.data.prevRankNo) === 0 ) {
          return '진입';

        } if( parseInt(params.data.rankNo) > parseInt(params.data.prevRankNo) ) {
          return <span className="cblue">▼ {params.data.prevRankNo}</span>

        } else if( parseInt(params.data.rankNo) < parseInt(params.data.prevRankNo) ) {
          return <span className="cred">▲ {params.data.prevRankNo}</span>

        } else if( parseInt(params.data.rankNo) === parseInt(params.data.prevRankNo) ) {
          return '-';

        } else {
          return '';
        }
      }
    },
  ]);

  // table column
  const [columnDefsDesign] = useState([
    { headerName:'순위', field: 'rankNo', width: 45, cellClass: 'cp center' },
    { headerName:'파일명', field: 'word', flex: 1, width: 200, cellClass: 'cp' },
    { headerName:'사이즈', field: 'fileSize', width: 100, cellClass: 'cp text-right',
      cellRendererFramework: function(params) {
        return formatBytes(params.data.fileSize);
      }
    },
    { headerName:'이전순위', field: 'prevRankNo', width: 80, cellClass: 'cp center',
      cellRendererFramework: function(params) {
        if( parseInt(params.data.prevRankNo) === 0 ) {
          return '진입';

        } if( parseInt(params.data.rankNo) > parseInt(params.data.prevRankNo) ) {
          return <span className="cblue">▼ {params.data.prevRankNo}</span>

        } else if( parseInt(params.data.rankNo) < parseInt(params.data.prevRankNo) ) {
          return <span className="cred">▲ {params.data.prevRankNo}</span>

        } else if( parseInt(params.data.rankNo) === parseInt(params.data.prevRankNo) ) {
          return '-';

        } else {
          return '';
        }
      }
    },
  ]);

  // table column
  const [columnDefsFile] = useState([
    { headerName:'순위', field: 'rankNo', width: 45, cellClass: 'cp center' },
    { headerName:'프로젝트', field: 'projectNumber', width: 100, cellClass: 'cp center' },
    { headerName:'프로젝트명', field: 'projectName', width: 200, cellClass: 'cp' },
    { headerName:'파일명', field: 'word', flex: 1, width: 200, cellClass: 'cp' },
    { headerName:'사이즈', field: 'fileSize', width: 80, cellClass: 'cp text-right',
      cellRendererFramework: function(params) {
        return formatBytes(params.data.fileSize);
      }
    },
    { headerName:'이전순위', field: 'prevRankNo', width: 65, cellClass: 'cp center',
      cellRendererFramework: function(params) {
        if( parseInt(params.data.prevRankNo) === 0 ) {
          return '진입';

        } if( parseInt(params.data.rankNo) > parseInt(params.data.prevRankNo) ) {
          return <span className="cblue">▼ {params.data.prevRankNo}</span>

        } else if( parseInt(params.data.rankNo) < parseInt(params.data.prevRankNo) ) {
          return <span className="cred">▲ {params.data.prevRankNo}</span>

        } else if( parseInt(params.data.rankNo) === parseInt(params.data.prevRankNo) ) {
          return '-';

        } else {
          return '';
        }
      }
    },
  ]);

  // table column
  const [columnDefs] = useState([
    { headerName:'순위', field: 'rankNo', width: 50, cellClass: 'cp center' },
    { headerName:'프로젝트번호', field: 'projectNumber', width: 120, cellClass: 'cp center' },
    { headerName:'프로젝트', field: 'word', width: 350, cellClass: 'cp', flex: 1 },
    { headerName:'이전순위', field: 'prevRankNo', width: 100, cellClass: 'cp center',
      cellRendererFramework: function(params) {
        if( parseInt(params.data.prevRankNo) === 0 ) {
          return '진입';

        } if( parseInt(params.data.rankNo) > parseInt(params.data.prevRankNo) ) {
          return <span className="cblue">▼ {params.data.prevRankNo}</span>

        } else if( parseInt(params.data.rankNo) < parseInt(params.data.prevRankNo) ) {
          return <span className="cred">▲ {params.data.prevRankNo}</span>

        } else if( parseInt(params.data.rankNo) === parseInt(params.data.prevRankNo) ) {
          return '-';

        } else {
          return '';
        }
      }
    },
  ]);

  /***************************************************************************************
   * 설명 : 열람 정보 리스트 가져오기 - 프로젝트 검색 순위, 디자인 파일 검색 순위, 파일 검색 순위, 열람신청 프로젝트 순위
  ***************************************************************************************/
  const getList = () => {
    let params = {...formik.values};

    getStatisticAccessApi(getApi, params, (response) => {
      if( response !== undefined && response.data.result ) {
        // 이전달 검색어
        if( response.data.data && response.data.data.length > 0 )
          setList1(response.data.data);
        else
          setList1([]);

        // 이번달 검색어
        if( response.data.data1 && response.data.data1.length > 0 )
          setList2(response.data.data1);
        else
          setList2([]);

        // 이전년도 검색어
        if( response.data.data2 && response.data.data2.length > 0 )
          setList3(response.data.data2);
        else
          setList3([]);

        // 이번년도 검색어
        if( response.data.data3 && response.data.data3.length > 0 )
          setList4(response.data.data3);
        else
          setList4([]);

      } else {
        setList1([]);
        setList2([]);
        setList3([]);
        setList4([]);
      }
    });
  }

  /***************************************************************************************
   * 설명 : 데이터 로딩
  ***************************************************************************************/
  useEffect(() => {
    getList();

  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formik.values.startDate]);

  /***************************************************************************************
   * 설명 : html 선언부
  ***************************************************************************************/
  return (
    <Layout>
      <section className="admin-cms-contents">
        <form onSubmit={formik.handleSubmit}>
          <header className="mt10">
            <div className="mb5">
              <BtnRefresh click={() => {
                formik.setValues(initialValues);
                formik.handleSubmit();
              }}></BtnRefresh>
              <BtnSearch></BtnSearch>

              <InputEx
                type="month"
                name="startDate"
                formik={formik}
                fullWidth={false}
                style={{width: '120px'}}
                label="검색 시작일"
              />
            </div>
          </header>
        </form>

        {/* 프로젝트 검색 순위 */}
        <section className="search-area">
          <section className="mt5 ag-theme-balham grid" style={{minWidth: 'calc(50% - 10px)', height:'calc(50vh - 80px)'}}>
            <h3 className="mb10">프로젝트 검색 순위</h3>
            <div className="" style={{ height: '100%'}}>
              <AgGridReact
                defaultColDef={{
                  sortable: true,
                  resizable: true,
                  filter: false,
                  lockVisible: true,
                  tooltipComponent: customTooltipAgGrid,
                }}
                tooltipShowDelay={0}
                tooltipHideDelay={2000}
                rowSelection = {'single'}
                columnDefs={columnDefsProject}
                rowData={list1}
                rowDragManaged={true}
                rowDragMultiRow={true}
                animateRows={true}
                overlayNoRowsTemplate = "검색된 내용이 없습니다."
              />
            </div>
          </section>

          <section className="mt5 ag-theme-balham grid" style={{minWidth: '50%', height:'calc(50vh - 80px)'}}>
            <h3 className="mb10">디자인 파일 검색 순위</h3>
            <div className="" style={{ height: '100%'}}>
              <AgGridReact
                defaultColDef={{
                  sortable: true,
                  resizable: true,
                  filter: false,
                  lockVisible: true,
                  tooltipComponent: customTooltipAgGrid,
                }}
                tooltipShowDelay={0}
                tooltipHideDelay={2000}
                rowSelection = {'single'}
                columnDefs={columnDefsDesign}
                rowData={list2}
                rowDragManaged={true}
                rowDragMultiRow={true}
                animateRows={true}
                overlayNoRowsTemplate = "검색된 내용이 없습니다."
              />
            </div>
          </section>
        </section>

        <section className="search-area mt40">
          <section className="mt5 ag-theme-balham grid" style={{minWidth: 'calc(50% - 10px)', height:'calc(50vh - 120px)'}}>
            <h3 className="mb10">파일 검색 순위</h3>
            <div className="" style={{ height: '100%'}}>
              <AgGridReact
                defaultColDef={{
                  sortable: true,
                  resizable: true,
                  filter: false,
                  lockVisible: true,
                  tooltipComponent: customTooltipAgGrid,
                }}
                tooltipShowDelay={0}
                tooltipHideDelay={2000}
                rowSelection = {'single'}
                columnDefs={columnDefsFile}
                rowData={list3}
                rowDragManaged={true}
                rowDragMultiRow={true}
                animateRows={true}
                overlayNoRowsTemplate = "검색된 내용이 없습니다."
              />
            </div>
          </section>

          <section className="mt5 ag-theme-balham grid" style={{minWidth: '50%', height:'calc(50vh - 120px)'}}>
            <h3 className="mb10">열람 신청 프로젝트 순위</h3>
            <div className="" style={{ height: '100%'}}>
              <AgGridReact
                defaultColDef={{
                  sortable: true,
                  resizable: true,
                  filter: false,
                  lockVisible: true,
                  tooltipComponent: customTooltipAgGrid,
                }}
                tooltipShowDelay={0}
                tooltipHideDelay={2000}
                rowSelection = {'single'}
                columnDefs={columnDefs}
                rowData={list4}
                rowDragManaged={true}
                rowDragMultiRow={true}
                animateRows={true}
                overlayNoRowsTemplate = "검색된 내용이 없습니다."
              />
            </div>
          </section>
        </section>
      </section>
    </Layout>
  );
}

/*****************************************************************************************
 * 설명 : default export 선언
*****************************************************************************************/
export default StatisticAccess;